import React from 'react';
import { useSelector } from 'react-redux';
import {
    Grid,
    Box,
    Typography,
    Divider,
    MenuItem,
    Chip,
    Checkbox,
} from '@material-ui/core';
import { HUB_TYPE_ENUM } from '../../../../../utils/constants';
import { formatOrgTime, isBlueDartOrg } from '../../../../../utils/appHelper';
import {
    getWeekDaysFromRoster,
    isSuperAdminOrAdmin,
} from '../../../../../utils/helper';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { CustomTextField } from '../../../../Textfield';
import HubHeader from './HubHeader';
import {
    HubSelector,
    StyledAutocomplete,
    StyledCustomTextField,
} from '../FormUI';
import { validateHubSelection } from '../../helper';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

export default function WorkInfoTabComponent({
    formik,
    workTabHubNShiftList,
    setWorkTabHubNShiftList,
    overlapShifts,
    bothShiftsIsThere,
    setAllowHubZoneEdit,
    setShiftsWithHub,
    getShiftfromHubId,
    getZonesFromHubId,
    orgCustomerMappings,
    fetchHubListWithFilters,
    fetchBusinessList,
    isPinCodeOrg,
    isAmazonOrg,
    isEdit,
}) {
    const [localworkTabHubNShiftList, setLocalworkTabHubNShiftList] =
        React.useState([]);
    const hubs = useSelector((state) => state?.staff?.hubs);
    const isBDOrg = isBlueDartOrg();
    const removeShift = useSelector(
        (state) =>
            state?.settings?.basicDetails?.settingsMap?.removeShift === 'true',
    );

    React.useEffect(() => {
        if (!isBDOrg) return;
        const hasUninitialized = workTabHubNShiftList.some((hub) => !hub?.primaryOperation);
        if (!hasUninitialized) return;

        setWorkTabHubNShiftList((prev) =>
            prev.map((h) =>
                !h?.primaryOperation
                    ? { ...h, primaryOperation: HUB_TYPE_ENUM.ECOM.value }
                    : h,
            ),
        );

        fetchHubListWithFilters(
            { orgCustomerIds: [], primaryOperation: HUB_TYPE_ENUM.ECOM.value },
            () => {},
            (err) => console.log('fetchHubListWithFilters err', err),
        );
    }, [workTabHubNShiftList.length]);

    const handleShiftDelete = (hub, shift, index) => {
        // const hubInfo = hubs.find((h) => h?.id === hub?.hubId);
        // if (hubInfo?.primaryOperation === HUB_TYPE_ENUM.FOOD.value) {
        //     setAllowHubZoneEdit(false);
        // }

        setWorkTabHubNShiftList((prev) => {
            return prev.map((hubShifts, indx) => ({
                ...hubShifts,
                shifts:
                    indx === index
                        ? hubShifts.shifts.filter((s) => s?.id !== shift?.id)
                        : hubShifts.shifts,
            }));
        });

        setShiftsWithHub((prev) => {
            return {
                ...prev,
                [hub?.hubId]: {
                    ...prev?.[hub?.hubId],
                    shifts: hub.shifts.filter((s) => s?.id !== shift?.id),
                },
            };
        });
    };

    const handlePrimaryOperationSelection = (e, index) => {
        fetchHubListWithFilters(
            {
                orgCustomerIds: [],
                primaryOperation: e?.target?.value,
            },
            () => {
                fetchBusinessList(
                    {
                        primaryOperation: e?.target?.value,
                    },
                    () => {
                        handleHubSelect(
                            {
                                primaryOperation: e?.target?.value,
                            },
                            index,
                        );
                    },
                    (err) => {
                        console.log('fetchBusinessList err', err);
                    },
                );
            },
            (err) => {
                console.log('fetchHubListWithFilters err', err);
            },
        );
    };

    const handleHubSelect = async (data, index) => {
        const hubInfo = data?.hubInfo;
        const alreadyExist = !!workTabHubNShiftList.find(
            (h) => h.primaryOperation === HUB_TYPE_ENUM.FOOD.value,
        );

        if (
            hubInfo?.primaryOperation !== HUB_TYPE_ENUM.ECOM.value &&
            !alreadyExist
        ) {
            setAllowHubZoneEdit(true);
        }

        setWorkTabHubNShiftList((prev) => {
            let returningData = [
                ...prev.map((hub, indx) => ({
                    ...hub,
                    ...(indx === index && {
                        ...data,
                    }),
                })),
            ];
            if (!!data?.primaryOperation) {
                returningData = [...returningData, {}];
            }
            return returningData;
        });

        try {
            if (!!data?.hubId) {
                await getShiftfromHubId(data?.hubId, index);
                await getZonesFromHubId(data?.hubId, index);
            }
        } catch (error) {
            console.error('Error fetching hub shifts or zones:', error);
        }
    };

    React.useEffect(() => {
        setLocalworkTabHubNShiftList(workTabHubNShiftList);
        return () => {
            setLocalworkTabHubNShiftList([]);
        };
    }, [workTabHubNShiftList]);

    let validateHub = validateHubSelection(workTabHubNShiftList);
    let isDedicatedHubAlreadySelected = workTabHubNShiftList?.some((hub) => {
        return hub?.hubInfo && hub?.hubInfo?.dedicatedSlotBookingEnabled;
    });
    let disableEdit =
        !!isEdit &&
        !isSuperAdminOrAdmin?.() &&
        isDedicatedHubAlreadySelected &&
        !isPinCodeOrg &&
        !isAmazonOrg;
    return (
        <Grid container spacing={2}>
            <Grid item container spacing={2}>
                <Grid item xs={12}>
                    <Typography
                        style={{
                            fontSize: '18px',
                            fontWeight: 600,
                            marginBottom: '18px',
                        }}
                        variant="body1"
                    >
                        Add Hubs & Shifts
                    </Typography>
                    <Divider />
                </Grid>
                {localworkTabHubNShiftList?.map((hub, index) => {
                    console.log('WorkInfoTabComponent hub', index, hub);
                    let filteredHubList =
                        hub?.shiftList?.filter(
                            (i) => !!i?.dedicatedSlotShift,
                        ) ?? [];
                    let mappedDedictedIds = filteredHubList?.map((i) => i?.id);
                    let isDedicatedHub =
                        hub?.hubInfo &&
                        hub?.hubInfo?.dedicatedSlotBookingEnabled;
                    // When removeShift is on, a FOOD rider on a non-slot hub can
                    // book slots from the app — but only if no shifts are added.
                    // Adding shifts to such a hub disables slot booking, so warn.
                    let showSlotWarning =
                        removeShift &&
                        hub?.primaryOperation === HUB_TYPE_ENUM.FOOD.value &&
                        !isDedicatedHub &&
                        hub?.shifts?.length > 0;
                    return (
                        <Grid item xs={6}>
                            <Box style={{ marginBottom: 8 }}>
                                <HubHeader
                                    hub={hub}
                                    hubs={hubs}
                                    orgCustomerMappings={orgCustomerMappings}
                                    workTabHubNShiftList={workTabHubNShiftList}
                                    setWorkTabHubNShiftList={
                                        setWorkTabHubNShiftList
                                    }
                                    setShiftsWithHub={setShiftsWithHub}
                                    setAllowHubZoneEdit={setAllowHubZoneEdit}
                                    index={index}
                                    disableEdit={disableEdit}
                                />
                                <Box
                                    style={{
                                        width: '100%',
                                        ...(!!hub?.primaryOperation
                                            ? {
                                                  borderBottomLeftRadius: 8,
                                                  borderBottomRightRadius: 8,
                                                  border: 'solid 1px rgba(38, 50, 56, 0.16)',
                                                  borderTop: 'none',
                                              }
                                            : {}),
                                    }}
                                >
                                    {!hub?.primaryOperation ? (
                                        isBDOrg ? (
                                            <CustomTextField
                                                label="Business Type"
                                                style={{ width: '100%' }}
                                                value="ECOM"
                                                disabled
                                            />
                                        ) : (
                                            <CustomTextField
                                                label="Select Business Type"
                                                select
                                                style={{
                                                    width: '100%',
                                                }}
                                                id="primaryOperation"
                                                name="primaryOperation"
                                                value={hub.primaryOperation}
                                                onChange={(e) =>
                                                    handlePrimaryOperationSelection(
                                                        e,
                                                        index,
                                                    )
                                                }
                                                isRequired={true}
                                                error={
                                                    formik.touched
                                                        .shiftTimingIds &&
                                                    Boolean(
                                                        formik.errors
                                                            .shiftTimingIds,
                                                    )
                                                }
                                                helperText={
                                                    !validateHub?.isValid
                                                        ? validateHub?.reason
                                                        : formik.touched
                                                              .shiftTimingIds &&
                                                          formik.errors
                                                              .shiftTimingIds
                                                        ? 'Select Business Type'
                                                        : ''
                                                }
                                                disabled={
                                                    !!disableEdit ||
                                                    !validateHub?.isValid
                                                }
                                            >
                                                {[
                                                    ...Object.keys(
                                                        HUB_TYPE_ENUM,
                                                    ).filter((i) => !!i),
                                                ].map((hubtype) => {
                                                    return (
                                                        <MenuItem
                                                            value={hubtype}
                                                        >
                                                            {hubtype}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </CustomTextField>
                                        )
                                    ) : hub.primaryOperation !==
                                          HUB_TYPE_ENUM.ECOM.value &&
                                      !hub?.business ? (
                                        <StyledCustomTextField
                                            label="Select Business"
                                            select
                                            style={{
                                                width: '100%',
                                            }}
                                            id="business"
                                            name="business"
                                            value={hub.business}
                                            onChange={(e) => {
                                                const customerId =
                                                    e?.target?.value;
                                                fetchHubListWithFilters(
                                                    {
                                                        orgCustomerIds: [
                                                            customerId,
                                                        ],
                                                        primaryOperation:
                                                            hub?.primaryOperation,
                                                    },
                                                    () => {
                                                        const custInfo =
                                                            orgCustomerMappings?.find(
                                                                (i) =>
                                                                    customerId ===
                                                                    i?.id,
                                                            );
                                                        handleHubSelect(
                                                            {
                                                                business:
                                                                    customerId,
                                                                custInfo,
                                                            },
                                                            index,
                                                        );
                                                    },
                                                    (err) => {
                                                        console.log('err', err);
                                                    },
                                                );
                                            }}
                                            isRequired={true}
                                            error={
                                                formik.touched.shiftTimingIds &&
                                                Boolean(
                                                    formik.errors
                                                        .shiftTimingIds,
                                                )
                                            }
                                            helperText={
                                                formik.touched.shiftTimingIds &&
                                                formik.errors.shiftTimingIds
                                                    ? 'Please select a business'
                                                    : ''
                                            }
                                        >
                                            {orgCustomerMappings?.length ? (
                                                orgCustomerMappings.map(
                                                    (cust) => {
                                                        return (
                                                            <MenuItem
                                                                value={cust?.id}
                                                            >
                                                                {
                                                                    cust?.aliasName
                                                                }
                                                            </MenuItem>
                                                        );
                                                    },
                                                )
                                            ) : (
                                                <MenuItem value={''}>
                                                    No Business Found
                                                </MenuItem>
                                            )}
                                        </StyledCustomTextField>
                                    ) : !hub?.hubId ? (
                                        <HubSelector
                                            hub={hub}
                                            index={index}
                                            hubs={hubs}
                                            workTabHubNShiftList={
                                                workTabHubNShiftList
                                            }
                                            onHubSelect={async (e) => {
                                                const hubId = e.target.value;
                                                const hubInfo = hubs?.find(
                                                    (i) => hubId === i?.id,
                                                );
                                                handleHubSelect(
                                                    {
                                                        hubId,
                                                        hubInfo,
                                                        ...(isBDOrg
                                                            ? {
                                                                  primaryOperation:
                                                                      HUB_TYPE_ENUM
                                                                          .ECOM
                                                                          .value,
                                                              }
                                                            : {}),
                                                    },
                                                    index,
                                                );
                                            }}
                                            error={
                                                formik.touched.shiftTimingIds &&
                                                Boolean(
                                                    formik.errors
                                                        .shiftTimingIds,
                                                )
                                            }
                                            helperText={
                                                formik.touched.shiftTimingIds &&
                                                formik.errors.shiftTimingIds
                                            }
                                        />
                                    ) : (
                                        <Box style={{}}>
                                            <StyledAutocomplete
                                                multiple={true}
                                                disableCloseOnSelect={true}
                                                disabled={false}
                                                limitTags={2}
                                                key={index}
                                                options={
                                                    hub?.shiftList?.filter(
                                                        (i) =>
                                                            !i?.dedicatedSlotShift,
                                                    ) || []
                                                }
                                                getOptionLabel={(option) =>
                                                    `${formatOrgTime(
                                                        option.startTimeEpochMillis,
                                                    )}-${formatOrgTime(
                                                        option.endTimeEpochMillis,
                                                    )}`
                                                }
                                                disableClearable
                                                filterSelectedOptions={false}
                                                value={hub?.shifts || []}
                                                onChange={(e, newValue) => {
                                                    setWorkTabHubNShiftList(
                                                        (prev) => {
                                                            return prev.map(
                                                                (i, indx) => {
                                                                    const data =
                                                                        indx ===
                                                                        index
                                                                            ? {
                                                                                  ...i,
                                                                                  shifts: newValue,
                                                                              }
                                                                            : {
                                                                                  ...i,
                                                                              };
                                                                    return data;
                                                                },
                                                            );
                                                        },
                                                    );
                                                    setShiftsWithHub((prev) => {
                                                        return {
                                                            ...prev,
                                                            [hub?.hubId]: {
                                                                ...prev?.[
                                                                    hub?.hubId
                                                                ],
                                                                shifts: newValue,
                                                            },
                                                        };
                                                    });
                                                }}
                                                includeInputInList={true}
                                                getLimitTagsText={(more) => {
                                                    let border = 'none';
                                                    hub?.shifts?.forEach(
                                                        (shift, indx) => {
                                                            if (indx > 1) {
                                                                border =
                                                                    bothShiftsIsThere ||
                                                                    overlapShifts.includes(
                                                                        shift.id,
                                                                    )
                                                                        ? '1px solid red'
                                                                        : 'none';
                                                            }
                                                            return shift;
                                                        },
                                                    );
                                                    return (
                                                        <Chip
                                                            style={{
                                                                border,
                                                            }}
                                                            label={`+${more}`}
                                                        />
                                                    );
                                                }}
                                                renderTags={(values, props) => {
                                                    return values?.map(
                                                        (shift) => {
                                                            const rosterDays =
                                                                !!shift?.rosterDays
                                                                    ? getWeekDaysFromRoster(
                                                                          shift?.rosterDays,
                                                                      )
                                                                    : [];
                                                            let dedicatedShift =
                                                                mappedDedictedIds?.includes(
                                                                    shift?.id,
                                                                );
                                                            return (
                                                                <Chip
                                                                    disabled={
                                                                        !!dedicatedShift
                                                                    }
                                                                    onDelete={
                                                                        shift?.slotShift
                                                                            ? null
                                                                            : () =>
                                                                                  handleShiftDelete(
                                                                                      hub,
                                                                                      shift,
                                                                                      index,
                                                                                  )
                                                                    }
                                                                    style={{
                                                                        marginRight: 4,
                                                                        border:
                                                                            bothShiftsIsThere ||
                                                                            overlapShifts?.includes(
                                                                                shift.id,
                                                                            )
                                                                                ? '1px solid red'
                                                                                : 'none',
                                                                    }}
                                                                    label={
                                                                        <Box>
                                                                            <Typography
                                                                                style={{
                                                                                    fontSize:
                                                                                        '12px',
                                                                                    fontWeight: 600,
                                                                                }}
                                                                            >
                                                                                {`${formatOrgTime(
                                                                                    shift?.startTimeEpochMillis,
                                                                                )}-${formatOrgTime(
                                                                                    shift?.endTimeEpochMillis,
                                                                                )}`}
                                                                            </Typography>

                                                                            {!!rosterDays?.length && (
                                                                                <Typography
                                                                                    style={{
                                                                                        fontSize:
                                                                                            '10px',
                                                                                        fontWeight: 700,
                                                                                        marginTop:
                                                                                            '2px',
                                                                                    }}
                                                                                >
                                                                                    {getWeekDaysFromRoster(
                                                                                        rosterDays?.rosterDays,
                                                                                    )
                                                                                        .map(
                                                                                            (
                                                                                                day,
                                                                                            ) =>
                                                                                                day?.shortName,
                                                                                        )
                                                                                        .join(
                                                                                            ', ',
                                                                                        )}
                                                                                </Typography>
                                                                            )}
                                                                        </Box>
                                                                    }
                                                                />
                                                            );
                                                        },
                                                    );
                                                }}
                                                renderOption={(
                                                    option,
                                                    { selected },
                                                ) => (
                                                    <Box
                                                        style={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            justifyContent:
                                                                'space-between',
                                                            width: '100%',
                                                            borderBottom:
                                                                '1px solid #EBEBEB',
                                                        }}
                                                    >
                                                        <Box>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '12px',
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {option?.name}
                                                                {!!option?.rosterShift && (
                                                                    <>{` (Slot) `}</>
                                                                )}
                                                            </Typography>
                                                            <Typography
                                                                style={{
                                                                    fontSize:
                                                                        '10px',
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {formatOrgTime(
                                                                    option.startTimeEpochMillis,
                                                                )}{' '}
                                                                -{' '}
                                                                {formatOrgTime(
                                                                    option.endTimeEpochMillis,
                                                                )}
                                                            </Typography>
                                                            {!!option?.rosterDays && (
                                                                <Typography
                                                                    style={{
                                                                        fontSize:
                                                                            '10px',
                                                                        fontWeight: 700,
                                                                        marginTop:
                                                                            '2px',
                                                                    }}
                                                                >
                                                                    {getWeekDaysFromRoster(
                                                                        option?.rosterDays,
                                                                    )
                                                                        .map(
                                                                            (
                                                                                day,
                                                                            ) =>
                                                                                day?.shortName,
                                                                        )
                                                                        .join(
                                                                            ', ',
                                                                        )}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                        <Checkbox
                                                            icon={icon}
                                                            style={{
                                                                marginRight: 8,
                                                            }}
                                                            color={'primary'}
                                                            checked={selected}
                                                        />
                                                    </Box>
                                                )}
                                                style={{
                                                    width: '100%',
                                                }}
                                                renderInput={(params) => (
                                                    <CustomTextField
                                                        {...params}
                                                        id={hub?.name}
                                                        name={hub?.name}
                                                        placeholder={
                                                            hub?.shifts?.length
                                                                ? ''
                                                                : !!isDedicatedHub
                                                                  ? 'Rider will choose from rider app'
                                                                  : 'Select Shift*'
                                                        }
                                                        fullWidth={true}
                                                        error={
                                                            formik.touched
                                                                .shiftTimingIds &&
                                                            Boolean(
                                                                formik.errors
                                                                    .shiftTimingIds,
                                                            )
                                                        }
                                                        helperText={
                                                            formik.touched
                                                                .shiftTimingIds &&
                                                            formik.errors
                                                                .shiftTimingIds
                                                        }
                                                    />
                                                )}
                                            />
                                        </Box>
                                    )}
                                </Box>
                                {showSlotWarning && (
                                    <Typography
                                        style={{
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            color: '#d9822b',
                                            marginTop: 4,
                                        }}
                                    >
                                        Slot tab will not be visible if shifts
                                        added
                                    </Typography>
                                )}
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    );
}
